import { RouteObject } from "react-router-dom"
import MainPage from "./mainPage"
import AboutUsPage from "./subPages/AboutUs"
import FeedbackPage from "./subPages/FeedbackPage"
import HelpCenter from "./subPages/HelpCenter"
import News from "./subPages/News"
import Service from "./subPages/Service"
export const myRoutes: RouteObject[] = [
    // {
    //     index: true,
    //     path: "",
    //     element: <MainPage />,
    // },
    {
        path: "feedback",
        element: <FeedbackPage />,
    },
    {
        path: "aboutus",
        element: <AboutUsPage />,
    },
    {
        path: "helpcenter",
        element: <HelpCenter />,
    },
    {
        path: "service",
        element: <Service />,
    },
    {
        path: "news",
        element: <News />,
    },
]
